import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import FormDataContext from '../context/formDataContext';
import { StemiInput, StemiInputProps } from '../../../components/Input';

type DjangoInputProps = {
  name: string;
} & StemiInputProps;

const DjangoInput: React.FC<DjangoInputProps> = ({
  className,
  name,
  type,
  placeholder,
  label,
  link,
  ...props
}) => {
  const formData = useContext(FormDataContext);
  const [value, setValue] = useState(formData.formValues[name] || '');

  useEffect(() => {
    setValue(formData.formValues[name] || '');
  }, [formData.formValues, name]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return (
    <StemiInput
      id={name}
      className={classNames(['form-group', className])}
      name={name}
      type={type}
      value={value}
      onChange={handleChange}
      errors={name ? formData.formErrors[name] : undefined}
      placeholder={placeholder}
      label={label}
      showPasswordToggle={type === 'password'}
      link={link}
      {...props}
    />
  );
};

export default DjangoInput;
